import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { IDetailTripResponse } from 'src/app/interfaces/Responses/IDetailTripResponse';
import { Image } from '../../../interfaces/Responses/IDetailTripResponse';
import { RealTimeService } from './../../../services/dashboards/real-time.service';

@Component({
  selector: 'neoris-filter-plate',
  templateUrl: './filter-plate.component.html',
  styleUrls: ['./filter-plate.component.css']
})
export class FilterPlateComponent {

  @Input() FP: string;

  tripID: string = '16227501297'
  response: IDetailTripResponse
  totalImages = 0
  images: Image[] = []
  plateNumber = ''
  amountOfJourneys = ''
  plant: string;
  AvgTime: string;

  @ViewChild('image') image: ElementRef;
  @ViewChild('pagination') pagination: ElementRef;

  constructor(
    private realTimeService: RealTimeService,
    private renderer: Renderer2
  ) {
    this.getTrucksByCheckpoint("3")
  }

  getDetailTrip() {
    this.realTimeService.getDetailTrip(this.tripID, '2', false).subscribe(
      res => {
        this.SetIDetailTripResponse(res)
      }
    )
  }

  getTrucksByCheckpoint(stepId: string) {
   
  }

  SetIDetailTripResponse(res: IDetailTripResponse) {
    this.response = res
    this.plateNumber = res.platE_NUMBER
    this.amountOfJourneys = res.amountofjourneys.toString()
    this.plant = res.plant
    this.AvgTime = res.avG_TIME
    this.images = res.images
    this.totalImages = this.images.length
    document.querySelector('cwc-pagination').setAttribute('total-pages', this.totalImages.toString())
    this.setImage(0)
  }

  getDetail() {
    this.getDetailTrip()
  }

  setImage(i: number): void {
    this.renderer.setAttribute(this.image.nativeElement, 'src', this.images[i].imagE_URL)
  }

  cwcChange(event: CustomEvent) {
    this.setImage(event.detail * 1 - 1)
  }
}
